import React, { Component, PropTypes } from 'react'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

class Menu extends Component {
    static propTypes = {
        account: PropTypes.shape({
            user: PropTypes.shape({
                crew: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    ica_complete: PropTypes.bool.isRequired,
                    personal_complete: PropTypes.bool.isRequired,
                    experience_complete: PropTypes.bool.isRequired,
                    crew_positions_complete: PropTypes.bool.isRequired,
                    gear_primary_complete: PropTypes.bool.isRequired,
                    gear_secondary_complete: PropTypes.bool.isRequired,
                    gear_tertiary_complete: PropTypes.bool.isRequired,
                }).isRequired,
            }).isRequired,
        }).isRequired,
        personal: PropTypes.shape({
            data: PropTypes.shape({
                type: PropTypes.string,
                type_obj: PropTypes.shape({
                    label: PropTypes.string.isRequired,
                }),
                crew_secondary_type: PropTypes.string,
                crew_secondary_type_obj: PropTypes.shape({
                    label: PropTypes.string.isRequired,
                }),
                crew_tertiary_type: PropTypes.string,
                crew_tertiary_type_obj: PropTypes.shape({
                    label: PropTypes.string.isRequired,
                }),
            }),
        }).isRequired,
        personalActions: PropTypes.shape({
            loadPersonal: PropTypes.func.isRequired,
        }).isRequired,
    }

    componentWillMount() {
        if (! this.props.personal.data) {
            this.props.personalActions.loadPersonal(this.props.account.user.crew.uuid)
        }
    }

    _handleToggle = (e) => {
        e.preventDefault()

        const menuNode = this.refs.menu

        if (menuNode.className === 'menu menu--open') {
            menuNode.className = 'menu menu--close'
        } else {
            menuNode.className = 'menu menu--open'
        }
    }

    _handleClose = (e) => {
        e.preventDefault()

        const menuNode = this.refs.menu

        if (menuNode.className === 'menu menu--open') {
            menuNode.className = 'menu menu--close'
        }
    }

    _handleLink = (path, e) => {
        e.preventDefault()

        this._handleToggle(e)

        browserHistory.push(path)
    }

    _handleClickMenu = (e) => {
        e.preventDefault()

        // Only the toggle the menu if clicked on a DIV and not an A, and not
        // a menu menu-section__icon.
        const targetTag = e.target.tagName

        if (targetTag === 'DIV') {
            this._handleToggle(e)
        }
    }

    getCurrentSection() {
        const onboardingData = this.props.account.user.crew

        if (! onboardingData.ica_complete) {
            if (window.location.pathname === '/ica') {
                return 'Contractor Agreement'
            }

            return 'Onboarding Instructions'
        }

        if (! onboardingData.personal_complete) {
            return 'Personal'
        }

        if (! onboardingData.experience_complete) {
            return 'Experience'
        }

        if (! onboardingData.crew_positions_complete) {
            return 'Crew Positions & Gear'
        }

        if (! onboardingData.gear_primary_complete) {
            return 'Gear'
        }

        if (! onboardingData.gear_secondary_complete) {
            return 'Gear'
        }

        if (! onboardingData.gear_tertiary_complete) {
            return 'Gear'
        }

        return null
    }

    render() {
        const menuLinkProps = {
            handleClose: this._handleClose,
        }

        const personalData = this.props.personal.data
        const onboardingData = this.props.account.user.crew

        // if we have no information on the crewmember, we can't do much here, so bail.
        if (! personalData) {
            return null
        }

        const crewSubmenu = []

        if (personalData.type) {
            crewSubmenu.push((
                <MenuLink
                    { ...menuLinkProps }
                    key="gear-primary"
                    path="/gear/primary"
                    title={ `\u00a0\u00a0\u00a0\u00a0①\u00a0\u00a0${ personalData.type_obj.label }` }
                />
            ))
        }
        if (personalData.crew_secondary_type) {
            crewSubmenu.push((
                <MenuLink
                    { ...menuLinkProps }
                    key="gear-secondary"
                    path="/gear/secondary"
                    title={ `\u00a0\u00a0\u00a0\u00a0②\u00a0\u00a0${ personalData.crew_secondary_type_obj.label }` }
                />
            ))
        }
        if (personalData.crew_tertiary_type) {
            crewSubmenu.push((
                <MenuLink
                    { ...menuLinkProps }
                    key="gear-tertiary"
                    path="/gear/tertiary"
                    title={ `\u00a0\u00a0\u00a0\u00a0③\u00a0\u00a0${ personalData.crew_tertiary_type_obj.label }` }
                />
            ))
        }

        let profileMenu = null

        if (! onboardingData.onboarding_complete) {
            const currentSection = this.getCurrentSection()

            profileMenu = (
                <div className="[ menu__section ] [ menu-section ]">
                    <div className="menu-section__header">
                        <div className="menu-section__icon menu-section__icon--avatar" />
                        <div className="menu-section__title">Onboarding</div>
                    </div>
                    <div className="menu-section__item-list">
                        <MenuLink { ...menuLinkProps } path="/" title={ currentSection } />
                    </div>
                </div>
            )
        }

        return (
            <div className="menu menu--close" onClick={ this._handleClickMenu } ref="menu">
                <div className="menu__container">
                    <div className="menu__header">
                        <a className="menu__logo" href="#" onClick={ this._handleLink.bind(this, '/') } />
                        <a className="menu__toggle" href="#" onClick={ this._handleToggle } />
                    </div>
                    <div className="menu__nav">
                        { onboardingData.ica_complete && (
                            <div className="[ menu__section ] [ menu-section ]">
                                <div className="menu-section__header">
                                    <div className="menu-section__icon menu-section__icon--dollar" />
                                    <div className="menu-section__title">Billing</div>
                                </div>
                                <div className="menu-section__item-list">
                                    <MenuLink { ...menuLinkProps } path="/jobs" title="Current Jobs & Billing" />
                                    <MenuLink { ...menuLinkProps } path="/jobs/history" title="Job History" />
                                    <MenuLink { ...menuLinkProps } path="/billing-instructions" title="Billing Instructions" />
                                    {/* <MenuLink
                                        { ...menuLinkProps }
                                        matchingPaths={ ['/banking/edit'] }
                                        path="/banking"
                                        title="Banking"
                                    /> */}
                                </div>
                            </div>
                        ) }
                        { profileMenu ||
                            <div className="[ menu__section ] [ menu-section ]">
                                <div className="menu-section__header">
                                    <div className="menu-section__icon menu-section__icon--avatar" />
                                    <div className="menu-section__title">Profile</div>
                                </div>
                                <div className="menu-section__item-list">
                                    <MenuLink { ...menuLinkProps } path="/profile" title="My Profile" />
                                    <MenuLink
                                        { ...menuLinkProps }
                                        path="/crew-positions"
                                        title="Crew Positions & Gear"
                                    />

                                    <div>{ crewSubmenu }</div>
                                </div>
                            </div>
                        }
                        <div className="[ menu__section ] [ menu-section ]">
                            <div className="menu-section__header">
                                <div className="menu-section__icon menu-section__icon--info" />
                                <div className="menu-section__title">Information</div>
                            </div>
                            <div className="menu-section__item-list">
                                { onboardingData.ica_complete &&
                                    <MenuLink
                                        { ...menuLinkProps }
                                        path="/ica"
                                        title="Contractor Agreement"
                                    />
                                }
                                <MenuLink { ...menuLinkProps } path="/code-of-conduct" title="Code of Conduct" />
                                <MenuLink
                                    { ...menuLinkProps }
                                    path="/production-guidelines"
                                    title="Production Guidelines"
                                />
                                <MenuLink { ...menuLinkProps } path="/about" title="About MWAC" />
                                <MenuLink { ...menuLinkProps } path="/faqs" title="FAQs" />
                                <MenuLink { ...menuLinkProps } path="/privacy-policy" title="Privacy Policy" />
                                <MenuLink { ...menuLinkProps } path="/terms-of-use" title="Terms of Use" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class MenuLink extends Component {
    static propTypes = {
        handleClose: PropTypes.func.isRequired,
        matchingPaths: PropTypes.array,
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
    }

    static defaultProps = {
        matchingPaths: [],
    }

    _handleLink = (e) => {
        e.preventDefault()

        this.props.handleClose(e)

        browserHistory.push(this.props.path)
    }

    _getLinkClassName() {
        const {
            path,
            matchingPaths,
        } = this.props

        let currentPath = window.location.pathname

        if (currentPath === '' || currentPath === '/') {
            currentPath = '/'
        }

        return classnames({
            'menu-item__link': true,
            'menu-item__link--active': currentPath === path || matchingPaths.includes(currentPath),
        })
    }

    render() {
        return (
            <a
                className={ this._getLinkClassName() }
                href={ this.props.path }
                onClick={ this._handleLink }
            >
                { this.props.title }
            </a>
        )
    }
}

export default Menu



// WEBPACK FOOTER //
// ./app/components/menu.js